import React from 'react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
    const usps = [
        {
            number: 'X+',
            text: 'Happy Customers Worldwide'
        },
        {
            number: 'X%',
            text: 'Customer Satisfaction Rate'
        },
        {
            number: '24/7',
            text: 'Customer Support Available'
        },
        {
            number: 'X',
            text: 'Premium Products'
        }
    ];

    return (
        <section className="section why-choose-us">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Why Choose Aroha</h2>
                    <p className="section-subtitle">Numbers that speak for themselves</p>
                </div>

                <div className="usps-grid">
                    {usps.map((usp, index) => (
                        <div key={index} className="usp-card">
                            <div className="usp-number">{usp.number}</div>
                            <p className="usp-text">{usp.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
